import { useSyncExternalStore } from "react";

const subscribe = (onChange: () => void) => {
  window.addEventListener("resize", onChange);
  return () => window.removeEventListener("resize", onChange);
};

/** The window's inner width, following resizes. */
export function useWindowWidth(): number {
  return useSyncExternalStore(subscribe, () => window.innerWidth);
}
